import React from 'react';
import { addCommas } from 'core/utils/helpers/numbers';

function Tier({ reward, minimumSpend, position }) {
  return (
    <div className="mn_tier" data-test="bonus-tier">
      <div className="mn_position">
        <span>{position}</span>
      </div>
      <div className="bonusInfo">
        <p><span className="mn_tierReward">{addCommas(reward)} bonus miles</span><br />
          when you spend {addCommas(minimumSpend)}
        </p>
      </div>
    </div>
  );
}

export default Tier;
